<template>
  <v-container>
    <v-layout>
      <v-flex>
        <div class="add-apk">
          <v-form class="add-apk-form" ref="form" lazy-validation>
            <div class="file-wrap">
              <input
                type="file"
                id="file"
                ref="file"
                @change="uploadFile"
                :rules="rules.emptyRules"
              >
              <div class="add-apk-info">
                <v-icon color="purple" size="90">attach_file</v-icon>
                <p>Drag and drop to upload</p>
                <span class="label-wrap">
                  or
                  <label for="file">browse</label> to choose a file
                </span>
              </div>
            </div>
            <v-layout class="text-fields-wrap justify-center">
              <v-flex xs4>
                <p class="video-info-name">Version</p>
                <v-text-field
                  v-model="apkVersion"
                  color="purple"
                  placeholder="Enter name"
                  :rules="rules.emptyRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs4 offset-xs2>
                <p class="video-info-name">Name</p>
                <v-text-field
                  v-model="apkName"
                  color="purple"
                  placeholder="Enter version"
                  return-masked-value
                  :rules="rules.emptyRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="apk-form-buttons text-xs-right">
              <v-btn outline color="purple" @click="$router.go(-1)">ОТМЕНА</v-btn>
              <v-btn color="purple" dark @click.prevent="submit">ДОБАВИТЬ</v-btn>
            </div>
          </v-form>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
export default {
  name: "add-apk",
  data: () => ({
    apkFile: "",
    apkName: "",
    apkVersion: "",
    rules: {
      emptyRules: [value => !!value || "This input cannot be empty"]
    }
  }),
  methods: {
    uploadFile(event) {
      this.apkFile = event.target.files[0];
    },
    submit() {
      console.log(this.apkFile);
      this.$refs.form.validate();
      let formData = new FormData();
      formData.append("apk", this.apkFile);
      formData.append("version_name", this.apkName);
      formData.append("version_code", this.apkVersion);
      formData.forEach((value, key) => {
        console.log("%s: %s", key, value);
      });
      axios
        .post(this.$hostname + "/admin/upload_apk", formData, {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        })
        .then(response => {
          console.log(response);
          this.$router.push("/apk");
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.add-apk {
  background-color: #fff;
  height: 100%;
  border-radius: 3px;

  .add-apk-form {
    .file-wrap {
      height: 250px;
      position: relative;
    }

    .add-apk-info {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: 700;
      text-align: center;

      .v-icon {
        opacity: 0.1;
      }

      p {
        font-size: 21px;
      }

      .label-wrap {
        font-size: 16px;
        color: #767676;

        label {
          color: #800057;
          cursor: pointer;
        }
      }
    }

    input[type="file"] {
      height: 100%;
      width: 100%;
      opacity: 0;
    }
  }
}
</style>
